export const LOOKUP = {
    ACCOUNT_OPENING_REASON: 'lookup_account_opening_reason',
    ACCOUNT_STATUS: 'lookup_account_status',
    ACCOUNT_TYPE: 'lookup_account_type',
    ACTION: 'lookup_action',
    ANNUAL_INCOME: 'lookup_annual_income',
    ANNUAL_INCOME_FCA: 'lookup_annual_income_fca',
    ANTICIPATED_INITIAL_DEPOSIT: 'lookup_initial_deposit',
    BANK_CARD_TYPE: 'lookup_bank_card_type',
    CONTACT_ROLE: 'lookup_contact_role',
    COUNTRY: 'lookup_country',
    COUNTRY_TAX_IDENTIFICATION_NUMBER: 'lookup_country_tax_identification_number_type',
    CURRENCY: 'lookup_currency',
    DEPOSIT_STATUS: 'lookup_deposit_status',
    DOCUMENT_TYPE: 'lookup_document_type',
    ECHELON_ACCOUNT_TYPE: 'lookup_echelonpay_account_type',
    ECHELON_BANK_BRANCH: 'lookup_echelonpay_bank_branch',
    EDUCATIONAL_BACKGROUND: 'lookup_educational_background',
    EMPLOYMENT_STATUS: 'lookup_employment_status',
    ENTITY_TYPE: 'lookup_entity_type',
    EXPECTED_CREDIT_OR_FUND_LOOKUP: 'lookup_expected_credit_or_fund',
    GENDER: 'lookup_gender',
    HEAR_ABOUS_US: 'lookup_hear_us',
    INDUSTRY: 'lookup_industry',
    INVESTMENT_OBJECTIVE: 'lookup_investment_objective',
    LEVERAGE: 'lookup_leverage',
    LIQUID_NET_WORTH: 'lookup_liquid_net_worth',
    LOCALE: 'lookup_locale',
    LOOKUP_ASIC: 'lookup_asic',
    LOOKUP_ASIC_DEMO: 'lookup_asic_demo',
    LOOKUP_COUNTRY_LICENCE_JURISDICTION: 'lookup_country_licence_jurisdiction',
    LOOKUP_COUNTRY_LICENCE_JURISDICTION_CN: 'cn-country-list.json',
    LOOKUP_DEMO_BALANCE_ACCOUNT: 'lookup_demo_balance_account',
    LOOKUP_EIG_PAG: 'lookup_eig_pag_method',
    LOOKUP_EIG_PAG_BANK: 'lookup_eig_pag_bank',
    LOOKUP_LATIN_BANK: 'lookup_latin_bank',
    LOOKUP_TIME_AT_CURRENT_ADDRESS: 'lookup_time_at_current_address',
    MALAY_MYR_BANK: 'lookup_xpay_malay_bank',
    PHILIP_BANK: 'lookup_dragonpay_philip_bank',
    PREVIOUS_TRADED_PRODUCTS: 'lookup_previous_traded_products',
    PROM0TION_TYPE: 'lookup_promotion_type',
    QUIZ_RESULT: 'lookup_quiz_result',
    PAYMENT_DEVICE_TYPE: 'lookup_payment_device_type',
    REQUEST_STATUS: 'lookup_request_status',
    REQUEST_TYPE: 'lookup_request_type',
    RISK_LEVEL: 'lookup_risk_level',
    ROLE_TYPE: 'lookup_role_type',
    RPN_CUP_BANK: 'lookup_rpncup_bank',
    SIZE_OF_WEALTH: 'lookup_size_of_wealth',
    SOURCE_OF_DEALING_FUNDS: 'lookup_source_of_dealing_funds',
    TAX_ID_EXEMPT_REASON: 'lookup_tax_id_exempt_reason',
    TENANT: 'lookup_tenant',
    TRADING_ACCOUNT_TYPE: 'lookup_trading_account_type',
    TRADING_EXPERIENCE: 'LOOKUP_TRADING_EXPERIENCE',
    TYPE_OF_BUSINESS: 'lookup_type_of_business',
    USER_GROUP: 'lookup_user_group',
    USER_ROLE: 'lookup_user_role',
    XPAY_CUP_BANK: 'lookup_payment_xpaycup',
    XPAY_INDO_BANK: 'lookup_xpay_indo_bank',
    XPAY_THAI_BANK: 'lookup_xpay_thai_bank',
    XPAY_UPOP_BANK: 'lookup_xpay_upop_bank',
    XPAY_VIETNAM_BANK: 'lookup_xpay_vina_bank'
};
